export default __webpack_public_path__ + "static/media/twitter-icon-lg.baa98523.png";